import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLoaderData } from 'react-router-dom';
const typeLabel = {
    feature: {
        text: '新機能',
        className: 'bg-teal-100 text-teal-800'
    },
    improvement: {
        text: '改善',
        className: 'bg-blue-100 text-blue-800'
    },
    bugfix: {
        text: 'バグ修正',
        className: 'bg-orange-100 text-orange-800'
    }
};
const Releases = ()=>{
    const releases = useLoaderData();
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-gray-50 py-16",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-3xl px-4",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "mb-4 text-center text-3xl font-bold text-gray-900",
                    children: "更新履歴"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-8 text-center text-gray-600",
                    children: "Histotimeの最新アップデート情報"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-4",
                    children: releases.map((release)=>/*#__PURE__*/ _jsxs(Link, {
                            to: `/releases/${release.id}`,
                            className: "block rounded-lg bg-white p-6 shadow-sm transition-shadow hover:shadow-md",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2 flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ _jsxs("span", {
                                            className: "font-mono text-sm font-semibold text-gray-500",
                                            children: [
                                                "v",
                                                release.version
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: `rounded-full px-2 py-0.5 text-xs font-medium ${typeLabel[release.type].className}`,
                                            children: typeLabel[release.type].text
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-sm text-gray-400",
                                            children: release.date
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "mb-2 text-lg font-semibold text-gray-900",
                                    children: release.title
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-sm text-gray-600",
                                    children: release.summary
                                })
                            ]
                        }, release.id))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-8 text-center",
                    children: /*#__PURE__*/ _jsx(Link, {
                        to: "/",
                        className: "inline-block rounded-full bg-teal-700 px-6 py-2 text-sm font-bold text-white transition-colors hover:bg-teal-800",
                        children: "トップページへ戻る"
                    })
                })
            ]
        })
    });
};
export default Releases;
